import { BillGenerationReportRequest, BillNumberRequest, CommonResponse, JobReportingInfoReq, LotInformationRequest, LotNumberReportResponseModel, ProductionLogResponse, ProductionProcessDashboardReq, ReportingInfoResponseModel, SubPlantTransferResponse, TransportChargesReq } from '@gtpl/shared-models/production-management';
import {CommonResponse as CommonResponseModel} from '@gtpl/shared-models/sale-management'
import axios from 'axios';
import connection from './connection';

export class ProdlogService {
    URL = connection.DEPLOY_URL + '/prod-log';

    async createProdLog(values): Promise<ProductionLogResponse> {
        return await axios.post(this.URL + '/createProdLog', values)
            .then(res => {
                return res.data
            })
    }

    async getLogDetailsForId(values): Promise<SubPlantTransferResponse> {
        return await axios.post(this.URL + '/getLogDetailsForId', values)
            .then(res => {
                return res.data
            })
    }
    async getLotTrackingReportData(req:LotInformationRequest): Promise<LotNumberReportResponseModel> {
        return await axios.post(this.URL + '/getLotTrackingReportData',req)
            .then(res => {
                return res.data
            })

    }
    async getAllReportingInfo(req: JobReportingInfoReq):Promise<ReportingInfoResponseModel>{

        return await axios.post(this.URL + '/getAllReportingInfo',req)
            .then(res => {
                return res.data
            })
    }
    async getLotNumberDetails():Promise<CommonResponse>{
        
        return await axios.post(this.URL+'/getLotNumberDetails')
        .then(res => {
            return res.data
        })
    }

    async getIntakeDetailsForProductionDashboard(req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL+'/getIntakeDetailsForProductionDashboard',req)
        .then(res => {
            return res.data
        })
    }
    
    async getSoakingDataForProductionReport(req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL+'/getSoakingDataForProductionReport',req)
        .then(res => {
            return res.data
        })
    }

    async getShiftWiseDataForProductionReport(req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL+'/getShiftWiseDataForProductionReport',req)
        .then(res => {
            return res.data
        })
    }

    async getTotalProductionForDashboard(req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL+'/getTotalProductionForDashboard',req)
        .then(res => {
            return res.data
        })
    }

    async getValueAdditionQuantitiesForProduction(req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL+'/getValueAdditionQuantitiesForProduction',req)
        .then(res => {
            return res.data
        })
    }

    async getValueAdditionFourForProduction(req?:ProductionProcessDashboardReq):Promise<CommonResponse>{
        return await axios.post(this.URL+'/getValueAdditionFourForProduction',req)
        .then(res => {
            return res.data
        })
    }

    async getBillInfoByBillNumber(req:BillNumberRequest):Promise<CommonResponseModel>{
        return await axios.post(this.URL+'/getBillInfoByBillNumber',req)
        .then(res => {
            return res.data
        })
    }

    async getWorkersInfoByBillNumber(req:BillNumberRequest):Promise<CommonResponseModel>{
        return await axios.post(this.URL+'/getWorkersInfoByBillNumber',req)
        .then(res => {
            return res.data
        })
    }

    async getDistinctBillNumber(req:BillNumberRequest):Promise<CommonResponse>{
        return await axios.post(this.URL+'/getDistinctBillNumber',req)
        .then(res => {
            return res.data
        })
    }

    async getDistinctContractorName(req:BillNumberRequest):Promise<CommonResponse>{
        return await axios.post(this.URL+'/getDistinctContractorName',req)
        .then(res => {
            return res.data
        })
    }

    async getContractorwiseBillGeneration(req?:BillGenerationReportRequest):Promise<CommonResponse>{
        return await axios.post(this.URL+'/getContractorwiseBillGeneration',req)
        .then(res => {
            return res.data
        })
    }

    async getContractorAndDayWiseData(req?:BillGenerationReportRequest):Promise<any>{
        return await axios.post(this.URL+'/getContractorAndDayWiseData',req)
        .then(res => {
            return res.data
        })
    }

    async wagesPayableVillageWise(req?: TransportChargesReq):Promise<CommonResponse>{
        return await axios.post(this.URL+'/wagesPayableVillageWise', req)
        .then(res => {
            return res.data
        })
    }
}